module.exports = __webpack_public_path__ + "img/8_53.faea4d24.png";